module.exports = __webpack_public_path__ + "img/red.101f3eb0.svg";